export const sources = {
	webp: "__VITE_ASSET__FKNdLzKnlftW3t_gzo81yw__ 400w, __VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__ 800w"
};
export const img = {
	src: "__VITE_ASSET__8HSUfh7cJHNFxCkInNzNXw__",
	w: 800,
	h: 1067
};
export default {
	sources: sources,
	img: img
};
